import { FC } from "react";
import { Stack, Typography } from "@mui/material";
import { CommitmentsTableName } from "./CommitmentsTableName";
import { CopyIconButton } from "../../../../../../../../common/CopyIconButton";
import { useHover } from "../../../../../../../../../utils/hooks/useHover.hook";

interface ProviderUniqueIdCellProps {
  id: string;
}

export const ProviderUniqueIdCell: FC<ProviderUniqueIdCellProps> = ({ id }) => {
  const { ref, hovered } = useHover();

  return (
    <Stack direction="row" spacing={1} alignItems="center" ref={ref}>
      <CommitmentsTableName
        id={id}
        type="savings_plan"
        name={<Typography variant="body2">{id}</Typography>}
      />

      <CopyIconButton data={id} visible={hovered} />
    </Stack>
  );
};
